import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { QrService } from '@services/qr.service';
import { PRIMENG_MODULES } from '@shared/primeng';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
	selector: 'app-qr-form',
	imports: [CommonModule, ReactiveFormsModule, ...PRIMENG_MODULES],
	templateUrl: './qr-form.component.html',
	styleUrl: './qr-form.component.scss',
})
export class QrFormComponent {
	private readonly fb = inject(FormBuilder);
	private readonly qrService = inject(QrService);
	private readonly dynamicDialogConfig = inject(DynamicDialogConfig);

	public form = this.fb.group({
		saleId: [null, [Validators.required]],
	});

	constructor() {
		console.log('QrFormComponent');
		console.log({ config: this.dynamicDialogConfig.data });
	}

	public onClose(): void {
		this.qrService.ref?.close();
	}

	public onSubmit(): void {
		this.qrService.ref?.close(this.form.value);
	}
}
